/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React from "react";
import Slider from "react-slick";
import type { Goods } from "./goodsModel";

type Props = {
  goods: Goods;
};
export const TenantGoodsSlider: React.FC<Props> = ({ goods }) => {
  const classesGoodsSliderDesign = goodsSliderDesign();

  const settings = {
    customPaging(i: number) {
      return <img key={i} src={goods.thumbnails[i]} alt="goods thumbnail" />; // TODO: alt確認
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchMove: false,
  };

  return (
    <div css={classesGoodsSliderDesign.root}>
      <Slider {...settings}>
        {goods.thumbnails.map((thumbnail, i) => {
          return (
            <div key={i} className="mainImage">
              <img src={thumbnail} alt="" />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

const goodsSliderDesign = () => {
  return {
    root: css`
      width: 90%;
      padding-top: 20px;
      margin: 0 auto 16px;
      @media screen and (min-width: 768px) {
        width: calc(59% - 17px);
        padding-top: 0;
        margin-right: 34px;
        margin-bottom: 0;
      }
      .mainImage {
        margin-bottom: 15px;
        img {
          width: calc(100% - 1px);
          border: 2px solid #e5e5e5;
        }
      }
      .slick-thumb {
        position: inherit;
        bottom: 0;
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: start;
        width: 100%;
        li {
          width: 17.6%;
          height: auto;
          margin: 0 3% 3% 0;
          border: 2px solid #e5e5e5;
          &:nth-of-type(5n) {
            margin: 0 0 3% 0;
          }
          &.slick-active {
            border: 2px solid #00c2ae;
          }
        }
        img {
          width: 100%;
        }
      }
    `,
  };
};
